"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayerAnalytics = void 0;
var Analytics_1 = require("./Analytics");
var VideoPlayerAnalytics = /** @class */ (function (_super) {
    __extends(VideoPlayerAnalytics, _super);
    function VideoPlayerAnalytics(campaign, video, analyticsTracker, disabled) {
        var _this = _super.call(this, campaign, analyticsTracker, disabled) || this;
        _this.videoPlaying = false;
        _this.initAnalytics = function () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            var _a = _this, video = _a.video, track = _a.track;
            if (!video)
                return;
            var eventInterval = null;
            video.onended = function () {
                track("$ended");
                _this.sendWatchTime(video);
                _this.videoPlayed = false;
                _this.videoPlaying = false;
                if (eventInterval) {
                    clearInterval(eventInterval);
                }
            };
            video.onplaying = function () {
                var currentVideo = _this.getVideoPlaying();
                track("$playing");
                if (!_this.videoPlayed && currentVideo === 'first-video') {
                    track("$play");
                    _this.videoPlayed = true;
                    eventInterval = setInterval(function () {
                        if (_this.videoPlaying) {
                            _this.sendWatchTime(video);
                        }
                    }, 5000);
                }
                if (!_this.videoPlaying) {
                    _this.videoPlaying = true;
                }
            };
            video.onplay = function () {
                _this.videoPlaying = true;
            };
            video.onpause = function () {
                track("$pause");
                _this.sendWatchTime(video);
                _this.videoPlaying = false;
            };
        };
        _this.getVideoPlaying = function () {
            var _a, _b, _c;
            if (!_this.video || !_this.validateIsCustomIntro())
                return 'first-video';
            var campaign = _this.campaign;
            var firstVideoUrl = (_b = (_a = campaign === null || campaign === void 0 ? void 0 : campaign.meta) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.sources[1].src;
            return ((_c = _this.video) === null || _c === void 0 ? void 0 : _c.src) === firstVideoUrl ? 'first-video' : 'second-video';
        };
        _this.sendWatchTime = function (video) {
            var videoPosition = _this.getVideoPlaying() === 'first-video' ? 0 : 1;
            _this.track('$watch', {
                start_watch: video.played.length > 0 ? parseInt(video.played.start(video.played.length - 1).toString()) : 0,
                end_watch: video.played.length > 0 ? parseInt(video.played.end(video.played.length - 1).toString()) : 0,
                total_length: parseInt(video.duration.toString()),
                videoPosition: videoPosition,
            });
        };
        _this.getDefaultVideoAnalyticsProperties = function () {
            var _a, _b, _c;
            var _d = _this, campaign = _d.campaign, getCurrentTime = _d.getCurrentTime, isFullscreenModeActive = _d.isFullscreenModeActive, video = _d.video;
            var asset = campaign.meta.video;
            if (video) {
                var videoPosition = _this.getVideoPlaying();
                // @ts-ignore
                if (videoPosition === 'second-video' && ((_b = (_a = campaign.meta) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b[0])) {
                    // @ts-ignore
                    asset = (_c = campaign.meta.assets) === null || _c === void 0 ? void 0 : _c[0];
                }
            }
            return {
                video: asset,
                current_time: getCurrentTime(),
                fullscreen_active: isFullscreenModeActive(),
                total_length: (video === null || video === void 0 ? void 0 : video.duration) || null,
                view_length: video === null || video === void 0 ? void 0 : video.currentTime,
            };
        };
        _this.isFullscreenModeActive = function () { return !!document.fullscreenElement; };
        _this.getCurrentTime = function () {
            var _a = _this, video = _a.video, formatTime = _a.formatTime;
            return formatTime((video === null || video === void 0 ? void 0 : video.currentTime) || 0);
        };
        _this.formatTime = function (time) {
            // eslint-disable-next-line no-bitwise
            var hrs = ~~(time / 3600);
            // eslint-disable-next-line no-bitwise
            var mins = ~~((time % 3600) / 60);
            // eslint-disable-next-line no-bitwise
            var secs = ~~time % 60;
            var ret = "";
            if (hrs > 0) {
                ret += hrs + ":" + (mins < 10 ? "0" : "");
            }
            ret += mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        };
        _this.video = video;
        _this.videoPlayed = false;
        _this.disabled = disabled;
        if (!_this.disabled) {
            _this.initAnalytics();
        }
        _this.track = _this.track.bind(_this);
        return _this;
    }
    VideoPlayerAnalytics.prototype.track = function (name, properties) {
        var _a = this, getDefaultVideoAnalyticsProperties = _a.getDefaultVideoAnalyticsProperties, disabled = _a.disabled;
        if (disabled)
            return false;
        return _super.prototype.track.call(this, name, __assign(__assign({}, getDefaultVideoAnalyticsProperties()), properties));
    };
    VideoPlayerAnalytics.prototype.validateIsCustomIntro = function () {
        var _a, _b, _c;
        var campaign = this.campaign;
        return !!((_c = (_b = (_a = campaign === null || campaign === void 0 ? void 0 : campaign.meta) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.sources);
    };
    return VideoPlayerAnalytics;
}(Analytics_1.Analytics));
exports.VideoPlayerAnalytics = VideoPlayerAnalytics;
